// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Q9mr","alertIcon":"ConfirmModal_alertIcon__3RaQT"};